export { default } from './Badge';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Badge/index.js
// module id = 807
// module chunks = 2